import { useEffect, useState } from 'react'
import { Properties, Property } from 'types/onboarding'
import {
  InnskraningAnalyticsStepEnum,
  trackInnskraningEvent,
} from 'utils/onboarding/analytics'

interface UseSelectPackagesProps {
  setProperties: (newProperties: Properties) => void
  properties: Properties
}
export const useSelectPackages = ({
  setProperties,
  properties,
}: UseSelectPackagesProps) => {
  const [modalVisible, setModalVisible] = useState(false)

  const [activeProperty, setActiveProperty] = useState<string | null>(null)

  const selectCheckbox = (checked: boolean, index: number) => {
    const newProperties = [...properties].map((p, i) =>
      index === i ? { ...p, selected: checked } : p
    )

    if (checked === false) {
      trackInnskraningEvent(
        InnskraningAnalyticsStepEnum.ADDRESS_REMOVE_BUTTON_CLICK
      )
    }

    setProperties(newProperties)
  }

  const selectProduct = (productId: string, propertyId?: string) => {
    const updatedProperties = properties.map((p) => {
      if (propertyId) {
        return p.ean === propertyId || p.fNumber === propertyId
          ? { ...p, product: productId }
          : p
      } else {
        return { ...p, product: productId }
      }
    })

    setProperties(updatedProperties)
    setModalVisible(false)
    setActiveProperty(null)
  }

  const findProduct = (propertyId: string | null) => {
    if (!propertyId) return undefined
    const property = properties.find(
      (p) => p.ean === propertyId || p.fNumber === propertyId
    )
    return property?.product
  }

  useEffect(() => {
    if (activeProperty) {
      setModalVisible(true)
    }
  }, [activeProperty])

  return {
    modalVisible,
    setModalVisible,
    activeProperty,
    setActiveProperty,
    selectCheckbox,
    selectProduct,
    findProduct,
  }
}
